<template>
  <Homepage index />
</template>
